import { useCreateOrderMutation } from './mutations/use-create-order-mutation';
import useGlobalStore from '@/stores/global.store';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import useCartStore from '@/stores/cart.store';
import notify from '@/utils/notify';
import useModalStore from '@/stores/modal.store';
import { ModalType } from '@/types/stores/modal';
import { useCode } from '@/hooks/use-code';
import { useShop } from '@/hooks/queries/use-shop';

export default function useCreateOrder() {
  const openModal = useModalStore((state) => state.open);
  const code = useCode();
  const navigate = useNavigate();
  const { data: shop } = useShop(code);
  const saleId = shop.sale.id;
  const groupId = shop.group.id;
  const userId = shop.user.id;
  const items = useCartStore((state) => state.items);
  const checkout = useGlobalStore((state) => state.checkout);

  const { mutate } = useCreateOrderMutation({
    onSuccess: (data) => {
      checkout(data.id);
      navigate(`/${code}/checkout`);
    },
    onMutate: () => openModal(ModalType.OrderValidating),
    onError: (error) =>
      openModal(ModalType.OrderValidationFailed, {
        message:
          'Ett problem uppstod när beställningen skapades. Vänligen försök igen. Om problemet kvarstår, kontakta oss på support@piggo.se.',
      }),
  });

  const create = React.useCallback(() => {
    if (items.length <= 0) {
      notify.error('Du måste lägga till produkter innan du kan lägga beställning');
      return;
    }

    return mutate({
      groupId,
      userId,
      saleId,
      // TODO: temporary placeholder until customer identification runs before order creation
      customerId: crypto.randomUUID(),
      orderItems: items.map((item) => ({ productId: item.id, quantity: item.quantity })),
    });
  }, [groupId, userId, saleId, items]);

  return { create };
}
